import Link from 'next/link'
import { RATINGS } from '@/lib/social-proof'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/sharp-solid-svg-icons'
import clsx from 'clsx'

type Props = {
  color?: 'white' | 'black'
}

export default function ProductReviewVariant2({ color = 'black' }: Props) {
  let textColor = color === 'black' ? 'text-rich-black' : 'text-clinical-white'

  return (
    <div
      className={clsx(
        'font-base flex gap-x-2 font-psans font-semibold',
        textColor,
      )}
    >
      <p>Loved by patients:</p>
      <RatingStars />
      <Link
        href="https://www.productreview.com.au/listings/nextclinic"
        target="_blank"
        rel={'noindex nofollow'}
        className="underline-offset-2 hover:underline"
      >
        {RATINGS.stars} ({RATINGS.reviews})
      </Link>
    </div>
  )
}

function RatingStars() {
  const stars = []
  for (let i = 0, total = RATINGS.stars; i < 5; i++, total--) {
    const currentFraction = (total > 0 ? Math.min(total, 1.0) : 0) * 100
    const invisiblePercentage = (100 - currentFraction).toFixed(0)

    stars.push(
      <div className="relative" key={i}>
        <FontAwesomeIcon className="text-gray-200" icon={faStar} size="sm" />
        <div
          className={`absolute -left-[30%] top-0 overflow-hidden`}
          style={{ left: `-${invisiblePercentage}%` }}
        >
          <FontAwesomeIcon
            className={`text-yellow-600`}
            icon={faStar}
            size="sm"
            style={{ transform: `translateX(${invisiblePercentage}%)` }}
          />
        </div>
      </div>,
    )
  }

  return (
    <div className="flex flex-col items-start text-sm">
      <div className="flex items-center gap-x-2">
        <div className="flex items-center">{stars}</div>
      </div>
    </div>
  )
}
